import {clsx} from 'clsx';
import {InputSelect} from '@/src/app/data/types/InputTypes';
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from '../shadcn-components/select';
import {translate} from '../../../app/shared/utils/localization-utils';

interface InputSelectProps {
	placeholder: string;
	isRequired?: boolean;
	className?: string;
	value: string;
	onChange: (value: string) => void;
	error?: string;
	selectData: InputSelect[] | string[];
}

export function SelectBox({
	className,
	placeholder,
	error,
	onChange,
	value,
	selectData,
	isRequired = false
}: InputSelectProps) {

	return (
		<div className={clsx('relative w-full', className)}>
			<Select value={value ?? ''} onValueChange={onChange}>
				<SelectTrigger
					className={clsx(
						'w-full h-[56px] bg-white rounded-[6px] outline outline-1 peer data-[state=open]:outline-2',
						error ? 'outline-error [&_svg]:stroke-error peer-aria-expanded:text-error data-[state=open]:outline-error hover:outline-error outline-2' : 'outline-gray-300 data-[state=open]:outline-blue hover:outline-gray-300 hover:outline-2',
						'focus-visible:ring-blue focus-visible: text-blue',
						''
					)}
				>
					<SelectValue className="peer" data-placeholder={value === ''}/></SelectTrigger>

				<SelectContent className="[&_svg]:text-blue bg-white max-h-[300px] max-w-min md:max-w-full overflow-y-auto">
					{selectData && selectData.length > 0 && selectData.map((selectItem, index) => {
						if (typeof (selectItem) == 'object') {
							return (<SelectItem key={index} className="text-blue text-base font-medium cursor-pointer p-3 hover:bg-blue-opacity-15 data-[highlighted]:outline-none focus-visible:ring-2"
												value={selectItem.value}>{selectItem.label}</SelectItem>);
						} else {
							return (<SelectItem key={index} className="text-blue text-base font-medium cursor-pointer p-3 hover:bg-blue-opacity-15 data-[highlighted]:outline-none focus-visible:ring-2"
												value={selectItem}>{translate(selectItem)}</SelectItem>);
						}
					})}
				</SelectContent>
			</Select>
			<label className={`pointer-events-none absolute cursor-text bg-white px-1 left-2.5 text-[16px] transition-all transform origin-left top-[16px] peer-aria-expanded:-top-2
	  						 peer-aria-expanded:text-sm peer-[&:not([data-placeholder])]:-top-2 peer-[&:not([data-placeholder])]:text-sm scale-90 ${error ? 'text-error peer-aria-expanded:text-error' : 'text-blue peer-aria-expanded:text-blue peer-focus-visible:text-blue'}`}>
				{placeholder}
				{isRequired ? <span> *</span> : ''}
			</label>
			{error && (
				<p className="mt-[6px] px-[16px] text-[12px] text-error leading-3">{error}</p>
			)}
		</div>
	);
}


